<template>
  <v-container>
      <v-row>
          <v-col class="px-0 py-2" cols="6">
              <h1>Notas fiscais</h1>
              <p>Gerencie as notas associadas ao cronograma.</p>
          </v-col>
          <v-col class="text-right px-0 py-2" cols="6">
              <v-btn
                v-if="userData.PermissaoAcoes.faturamento.includes('addnotafiscal')"
                outlined
                small
                height="30px"
                color="primary"
                depressed
                @click="openNotaFiscalDlg()"
              >Adicionar nota</v-btn>
              <v-tooltip v-else center bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                  outlined
                  color="rgb(151 151 151 / 58%)"
                  small
                  height="30px"
                  depressed
                  v-bind="attrs"
                  v-on="on"
                  >Adicionar nota</v-btn>
                </template>
                <span class="px-3 py-1 ma-0" style="border: solid 1px #999; border-radius: 5px; background-color: #FFF;">
                  Você não possui permissão para executar esta ação.
                </span>
              </v-tooltip>
          </v-col>
          <v-col class="px-0 py-0" cols="12" sm="6" md="4">
            <v-text-field
              v-model="search"
              placeholder="Filtrar por número"
              single-line
              outlined
              dense
              hide-details
            ></v-text-field>
          </v-col>
          <!-- <v-col class="px-2 py-0" cols="12" sm="6" md="8">
              <v-btn
                v-show="!showBtn"
                max-width="100%"
                height="40px"
                color="primary"
                depressed
                class="px-2"
                @click="filter(numero_nota)"
              >filtrar</v-btn>
              <v-btn
                v-show="showBtn"
                outlined
                max-width="100%"
                height="40px"
                color="primary"
                depressed
                class="px-2"
                @click="filter(null)"
              >limpar</v-btn>
          </v-col> -->
          <v-col class="px-0 py-6" cols="12">
              <NotasList
                :headers="headers"
                :list="list"
                :getList="(page) => getList(filter, page)"
                :delItem="(item) => deleteItem(item)"
                :editItem="(id) => openNotaFiscalDlg(id)"
                :assocItem="(nota) => openAssociarLotesDlg(nota)"
                :getFile="(item, tipo) => getFile(item, tipo)"
                :search="search"
                :userData="userData"
                :parameter="dadosCronograma"
              />
                <!-- :pagination="pagination" -->
          </v-col>
      </v-row>
      <AssociarLotesDlg
        :showOpen="dialogAssociar"
        :showClose="(val) => showClose(val)"
        :listLotes="listLotes"
        :notaFiscal="notaItem"
        :associaLotes="(item) => confirmAssociaLotes(item)"
      />
      <CadastroNotaFiscalDlg
        :notaFiscal="notasFiscais"
        :obrigatorio="obrigatorio"
        :showOpen="dialog"
        :showClose="(val) => showClose(val)"
        :sendForm="(formData, file) => saveItem(formData, file)"
      />
  </v-container>
</template>

<script>
import { mapState } from "vuex"
import NotasList from './NotasList'
import CadastroNotaFiscalDlg from './CadastroNotaFiscalDlg'
import AssociarLotesDlg from './AssociarLotesDlg'
export default {
  components: {
    NotasList,
    CadastroNotaFiscalDlg,
    AssociarLotesDlg
  },
  data() {
    return {
      cronogramaId: null,
      dialog: false,
      dialogAssociar: false,
      headers: [
          { text: "Número", align: "start", value: "numero", sortable: false, 'filterable':true },
          { text: "Emissão", value: "emissao", sortable: false, 'filterable':false },
          { text: "Valor (R$)", value: "valor", sortable: false, 'filterable':false },
          { text: "Link", value: "link", sortable: false, 'filterable':false },
          // { text: "Arquivo", value: "arquivo", sortable: false },
          { text: "Lotes assoc.", value: "lotes_assoc", sortable: false, 'filterable':false  },
          { text: "Baixar", value: "baixar", sortable: false, 'filterable':false  },
          { text: "Editar", value: "editar", sortable: false, 'filterable':false  },
          { text: "Excluir", value: "excluir", sortable: false, 'filterable':false  },
      ],
      list: [],
      listLotes: [],
      notasFiscais: {},
      numero_nota: null,
      obrigatorio: [],
      pagination: {
        limit: 99999,
        offset: 1,
        current_page: 1,
      },
      search: '',
      showBtn: false,
      showNota: false,
      notaItem: null
    }
  },
  computed: {
    ...mapState({
      grupoEconomico: (state) => state.permissions.grupoEconomico,
    }),
  },
  watch: {
    dadosCronograma(cronograma) {
      if(!this.showLotes){
        this.cronogramaId = cronograma.id
        let opts = { 
          grupo_economico: this.grupoEconomico,
          cronograma_id: cronograma.id, 
          numero: null
        }
        this.getList(opts)
      }
      if (cronograma.config.FAT_NOTA_FISCAL_CAMPOS_OBRIGATORIOS && cronograma.status=='F') 
        this.showNota = true
    },
    // showLotes(val){
    //   if(!val && this.cronogramaId != this.dadosCronograma.id){
    //       this.cronogramaId = this.dadosCronograma.id
    //       let opts = { 
    //         grupo_economico: this.grupoEconomico,
    //         cronograma_id: this.dadosCronograma.id, 
    //         numero: null
    //       }
    //       this.getList(opts)
    //   }
    // }
  },
  mounted() {
    this.cronogramaId = this.dadosCronograma.id
    let opts = { 
      grupo_economico: this.grupoEconomico,
      cronograma_id: this.dadosCronograma.id, 
      numero: null
    }
    this.getList(opts)

  },
  methods: {
    filter(numero) {
      if (numero != null) {
        this.showBtn = true
      } else {
        this.showBtn = false
        this.numero_nota = null
      }
      let opts = {
        grupo_economico: this.grupoEconomico,
        cronograma_id: this.cronogramaId,
        numero: numero
      }
      this.getList(opts)
    },
    showClose(val) {
      this.dialog = val
      this.dialogAssociar = val;
    },
    deleteItem(item) {
      let paramModal = {
        type: "error",
        title: "Excluir nota fiscal?",
        message: `Ao excluir nota fiscal de número: ${item.numero}, não estará mais disponível no cronograma. Essa alteração não poderá ser desfeita.`,
        callback: () => {
          this.deleteNotaFiscal(item)
        },
        btConfirm: { name: "Ok", show: true, color: '#D0021B' },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    openNotaFiscalDlg(idNota){
      this.dialog = true
      this.$store.commit("showLoader",  { circle: true })
      let { prestador_id, operadora_ans_id, login_prestador } = this.dadosCronograma
        let opts = {
          query: [{ 
            Modulo: "Portal",
            Acao: "getparametrizacoes",
            Payload: {
              grupo_economico: this.grupoEconomico,
              prestador_id,
              operadora_ans_id,
              login_prestador
            }
          }],
          noLoader: true
        }
        this.$store.dispatch("request/doRequest", opts).then(resp => {
          this.obrigatorio = resp.parametros && resp.parametros.FAT_NOTA_FISCAL_CAMPOS_OBRIGATORIOS? resp.parametros.FAT_NOTA_FISCAL_CAMPOS_OBRIGATORIOS : []
          if(idNota){
            this.getNotaFiscal(idNota)
          } else {
            this.$store.commit("hideLoader")
          }
        })
    },
    openAssociarLotesDlg(nota) {
      this.notaItem = nota;
      this.getLotes();
      this.dialogAssociar = true;
    },
    getList(filter) {
      // this.pagination.offset = page? page : 1
      // let payload = filter? Object.assign(filter, { grupo_economico: this.grupoEconomico }) : { grupo_economico: this.grupoEconomico }// this.grupoEconomico}
      let obj = {
        query: [
          {
            Modulo: "Faturamento",
            Acao: "getnotasfiscais",
            Payload: {
              grupo_economico: this.grupoEconomico,
              cronograma_id: this.cronogramaId,
              operadora_ans_id: this.dadosCronograma.operadora_ans_id,
              numero: filter? filter.numero : null
            },
          },
        ],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
        this.$store.commit("hideLoader")
        return
        }
        // let { dados, total_pages, current_page } = response
        this.list = response.dados
        // this.pagination.total_pages = total_pages
        // this.pagination.offset = current_page
        // this.pagination.current_page = current_page
      })
    },
    getNotaFiscal(idNota) {
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "getnotafiscal",
          Payload: {
            grupo_economico: this.grupoEconomico,
            id: idNota,
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.notasFiscais = response.notaFiscal
        this.$store.commit("hideLoader")
        // this.dialog = true
        
      })
    },
    getLotes() {
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "getlotes",
          Payload: {
            grupo_economico: this.grupoEconomico,
            prestador_id: this.dadosCronograma.prestador_id,
            cronograma_id: this.cronogramaId
          }
        }],
      }

      this.$store.dispatch("request/doRequest", obj).then(response => {
        this.listLotes = response.dados; 
      });

      this.$store.commit("hideLoader")
    },
    getFile(item, tipo){
      let obj
      switch (tipo) {
        case 'csv': 
        obj = {
          filename: item.anexo,
          query: [
            {
              Modulo: "Faturamento",
              Acao: "getcsvprevistofaturadooperadora",
              Payload: {
                grupo_economico: this.grupoEconomico
              },
            },
          ],
        }
        break
      }
      this.$store.dispatch("request/getFile", obj)
    },
    saveItem(formData, file) {
      formData.grupo_economico = this.grupoEconomico
      formData.cronograma_id = this.cronogramaId
      formData.operadora_ans_id = this.dadosCronograma.operadora_ans_id
      formData.prestador_id = this.dadosCronograma.prestador_id
      let acao = formData.id ? "updatenotafiscal" : "addnotafiscal" 
      let payload = JSON.stringify(formData)
      var data = new FormData();
      data.append('Modulo', 'Faturamento');
      data.append('Acao', acao);
      data.append('Payload', payload);
      data.append('File', file);

      this.$store.dispatch("request/sendFile", data).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        } 
        this.showClose(false)
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            let opts = { id:this.cronogramaId} 
            this.getList(opts)
          },
          btConfirm: { name: "Ok", show: true },
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
    confirmAssociaLotes(item) {
      let paramModal = {
        type: "warning",
        title: "Confirmar ação",
        message: "Você poderá editar novamente quando necessário",
        callback: () => {
          this.associaLotes(item)
        },
        btConfirm: { name: "Salvar", show: true },
        btCancel: { name: 'Cancelar', show: true }
      }
      this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
    },
    associaLotes(item) {
      let loteObj = item.map(lote => Object.assign({ 
        lote_id: lote.id, 
        dt_alteracao: lote.nota_fiscal_dt_alteracao 
      }));

      var payload = Object.assign({
        lotes: [...loteObj], 
        nota_fiscal_id: [this.notaItem.id], 
        prestador_id: this.dadosCronograma.prestador_id 
      });

      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "associarnotafiscal",
          Payload: {
            grupo_economico: this.grupoEconomico,
            ...payload
          }
        }],
      }

      this.$store.dispatch('request/doRequest', obj).then((response) => {
          if (!response || response.isAxiosError || response.error) {
            this.$store.commit('hideLoader');
            return;
          }

          let paramModal = {
            type: 'success',
            title: 'Sucesso!',
            message: response.mensagem ?? 'Associação efetuada com sucesso',
            callback: () => {
              this.dialogAssociar = false;
              this.getList();
            },
            btConfirm: { name: 'Ok', show: true },
            btCancel: { show: false },
          };
          this.$store.commit('confirmMessage/showConfirmMessage', paramModal);
        });
    },
    deleteNotaFiscal(item) {
      let obj = {
        query: [{ 
          Modulo: "Faturamento",
          Acao: "deletenotafiscal",
          Payload: {
            grupo_economico: this.grupoEconomico,
            id: item.id,
            dt_alteracao: item.dt_alteracao,
            prestador_id: this.dadosCronograma.prestador_id
          }
        }],
      }
      this.$store.dispatch("request/doRequest", obj).then((response) => {
        if (!response || response.isAxiosError || !response.sucesso) {
          this.$store.commit("hideLoader");
          return;
        }
        let paramModal = {
          type: "success",
          title: "Sucesso!",
          message: response.mensagem,
          callback: () => {
            let opts = { id: this.cronogramaId }
            this.getList(opts)
          },
          btConfirm: { name: "Ok", show: true },
          btCancel: { name: 'Cancelar', show: false }
        }
        this.$store.commit("confirmMessage/showConfirmMessage", paramModal);
      })
    },
  },
  props: {
    dadosCronograma: Object,
    showLotes: Boolean,
    userData: Object,
    parametros: Object
  }
}
</script>

<style>

</style>